import 'js/components/main/AppLaunchTimer';
import 'js/components/main/AutomaticWithdrawLimit';
import 'js/components/main/Balance';
import 'js/components/main/BankIDAuth';
import 'js/components/main/Banner';
import 'js/components/main/BonusMultiview';
import 'js/components/main/BingoScheduler';
import 'js/components/main/Cashier/QuickDeposit';
import 'js/components/main/CashierIframe';
import 'js/components/main/CasinoLeaderBoard';
import 'js/components/main/ChangePassword';
import 'js/components/main/ClientIp';
import 'js/components/main/CloseAccount';
import 'js/components/main/Comppoints';
import 'js/components/main/ContactPreferences';
import 'js/components/main/CookieSettings';
import 'js/components/main/DateTimeDisplay';
import 'js/components/main/DetailedTransactionHistory';
import 'js/components/main/DynamicChangeDetails';
import 'js/components/main/DynamicChangePassword';
import 'js/components/main/DynamicChangePin';
import 'js/components/main/DynamicForgotEmail';
import 'js/components/main/DynamicForgotPassword';
import 'js/components/main/DynamicForgotUsername';
import 'js/components/main/DynamicRegistration';
import 'js/components/main/DynamicValidatePassword';
import 'js/components/main/FacebookRegistration';
import 'js/components/main/FreeSpinsBalance';
import 'js/components/main/FundTransfer';
import 'js/components/main/Games';
import 'js/components/main/GameHistory';
import 'js/components/main/GamesInfo';
import 'js/components/main/Identt';
import 'js/components/main/IdenttManual';
import 'js/components/main/Jumio';
import 'js/components/main/GoldenChipsBalances';
import 'js/components/main/LastLoginDate';
import 'js/components/main/LeaderBoard/Slider';
import 'js/components/main/LeaderBoard/RaceDetails';
import 'js/components/main/LeaderBoard/RacesList';
import 'js/components/main/LoggedIn';
import 'js/components/main/LoggedOut';
import 'js/components/main/LoginHistory';
import 'js/components/main/LoginNotificationsPreferences';
import 'js/components/main/Kambi';
import 'js/components/main/MobileCashier';
import 'js/components/main/PageRoute';
import 'js/components/main/PassTheParcel';
import 'js/components/main/PhoneVerification';
import 'js/components/main/PinChange';
import 'js/components/main/ProductLimits';
import 'js/components/main/PromoCode';
import 'js/components/main/PromotionCode';
import 'js/components/main/ReduxComponentExample';
import 'js/components/main/ReferFriend';
import 'js/components/main/Registration';
import 'js/components/main/ResponsibleGaming';
import 'js/components/main/ResponsibleGamingHistory';
import 'js/components/main/ResponsibleGamingSingleBetLimit';
import 'js/components/main/ScheduledBreaks';
import 'js/components/main/SendVerificationEmail';
import 'js/components/main/SessionTicker';
import 'js/components/main/SportsbookApp';
import 'js/components/main/SportsbookBalance';
import 'js/components/main/SportsbookBetconstruct';
import 'js/components/main/SportsbookGamingHistory';
import 'js/components/main/SportsbookWidget';
import 'js/components/main/TermsAndConditionsHistory';
import 'js/components/main/ToggleBalance';
import 'js/components/main/TopWinners';
import 'js/components/main/TruNarrative';
import 'js/components/main/TwoFactorAuthenticationPreferences';
import 'js/components/main/UnauthorizedNotification';
import 'js/components/main/UnsubscribeMarketing';
import 'js/components/main/UpdateDetails';
import 'js/components/main/UrlTemplateLink';
import 'js/components/main/UserInfo';
import 'js/components/main/W2GReportingForm';
import 'js/components/main/WalletLinking';
import 'js/components/main/WebContent';
import 'js/components/common/FormFields/components/Checkbox';
import 'js/components/common/FormFields/components/Input';
import 'js/components/common/FormFields/components/Radio';
import 'js/components/common/FormFields/components/Select';
import 'js/components/common/FormFields/components/Toggle';
import 'js/components/common/FormFields/components/InputGroup';

/**
 * Deprecated components. Will be deleted soon
 */
import 'js/components/main/FormTestComponent';

/**
 * Disabled components. You can put imports here to reduce bundle size
 */
// import 'some-cool-component';
/**
 * New components that will be released soon
 */

// import 'js/components/main/NeonUpgradeAccount';

// TODO after moving from mainUnreleased
// remove BB header (also styles)
// remove "header.scss" variables from "variables-lic.scss"
// import 'js/components/mainUnreleased/DefaultHeader';

// todo fix the description in the .dat file, the user may have the ability to cancel bonuses,
// for this you need to add the attribute showcancelbutton="true"
// and remove dispatcher.dispatch('notification-bonus:updated') in all places
// import 'js/components/mainUnreleased/BonusHistory';
